import React from 'react';
import LaboratoryOrdersGrid from './LaboratoryOrdersGrid';
import LaboratoryOrdersTable from './LaboratoryOrdersTable';
import '../patients/PatientsView.css';
import './LaboratoryOrdersView.css';

const LaboratoryOrdersView = ({
  orders,
  timezone,
  manualStatusOptions,
  getDisplayStatus,
  formatLaboratoryDate,
  onEdit,
  onStatusChange,
  onCancel,
  onUpload,
  uploadingOrderId
}) => {
  return (
    <div className="patients-view laboratory-orders-view">
      <div className="mobile-only">
        <LaboratoryOrdersGrid
          orders={orders}
          timezone={timezone}
          manualStatusOptions={manualStatusOptions}
          getDisplayStatus={getDisplayStatus}
          formatLaboratoryDate={formatLaboratoryDate}
          onEdit={onEdit}
          onStatusChange={onStatusChange}
          onCancel={onCancel}
          onUpload={onUpload}
          uploadingOrderId={uploadingOrderId}
        />
      </div>

      <div className="desktop-only">
        <LaboratoryOrdersTable
          orders={orders}
          timezone={timezone}
          manualStatusOptions={manualStatusOptions}
          getDisplayStatus={getDisplayStatus}
          formatLaboratoryDate={formatLaboratoryDate}
          onEdit={onEdit}
          onStatusChange={onStatusChange}
          onCancel={onCancel}
          onUpload={onUpload}
          uploadingOrderId={uploadingOrderId}
        />
      </div>
    </div>
  );
};

export default LaboratoryOrdersView;